import { render, staticRenderFns } from "./SectionClose.vue?vue&type=template&id=09418dd2&"
import script from "./SectionClose.vue?vue&type=script&lang=js&"
export * from "./SectionClose.vue?vue&type=script&lang=js&"
import style0 from "./SectionClose.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports